import axiosClient from "../axiosClient";
import axiosClientCamServices from "../axiosClientCamSevices";
export const serviceApi = {
  getListService: () => {
    return axiosClient.get("/service/get-list-services/");
  },
  getListServiceRegistered: (param) => {
    return axiosClient.get("/camServiceRegister/get-list-service-register-with-camera-code/", {
      params: param
    });
  },
  getListCameraAi: (service_code) => {
    const params = service_code?{ai_service_code:service_code}:{}
    return axiosClient.get("/statEventAI/get-info-stat-event-ai/",{
      params:params
    });
  },
  getInfoServicePackCSC: (param) => {
    return axiosClientCamServices.get(`services/getservicebycode/${param}`)
  }
};
